import React from "react";

import BlogEventLayout from "../components/blogLayoutComp";
import SEO from "../components/seo";

//import mainImg from "../images/linkedinEvent.jpeg";
import mainImg from "../images/eventHeader.jpeg";
import dev from "../images/eventPerson1.jpeg";
import anj from "../images/eventPerson2.jpeg";
import oneImg from "../images/one.jpeg";
import twoImg from "../images/two.jpeg";
import threeImg from "../images/three.jpeg";
import fourImg from "../images/four.jpeg";
import fiveImg from "../images/five.jpeg";
import sixImg from "../images/six.jpeg";
import sevenImg from "../images/seven.jpeg";
import eightImg from "../images/eight.jpeg";
import nineImg from "../images/nine.jpeg";


function EventsBlogDetailsPage() {

  return (
    <BlogEventLayout
      title="Fireside Chat On Entrepreneurship  - In Conversation With Devaiah Bopanna and Anjana Kamath"
      brief=" In the ‘Fireside Chat On Entrepreneurship’, we talked to two entrepreneurs from our alma-mater, Devaiah Bopanna and Anjana Kamath, on the 18th of October, 2020. Hosted by Suhas Motwani, the discussion touched upon their life at BMS back in the day, their journeys and their experiences as entrepreneurs."
      heading1 = "Entrepreneurship - From Idea to Business"
      breif1 = "“To win without risk is to triumph without glory”. Entrepreneurs risk a lot in the conquest of making a tangible difference to the world. The journey, though tumultuous, is immensely gratifying, and the learnings, monumental. And the rewards for building on your own ideas can be boundless. "
      heading2 = ""
      imageMain={mainImg}
      blogVideoSrc = {[
        { "link":"https://www.instagram.com/p/CGj6U7DjOmf/?utm_source=ig_web_copy_link", "title" : "Video 1"},
        { "link" : "https://www.instagram.com/tv/CGkcnTijCRR/?utm_source=ig_web_copy_link", "title" : "Video 2" }]
      }
      extraContent =
      {
      <div>
        <div className="container mx-auto flex flex-wrap pt-4 pb-12" id="programs">

            <h3 className="w-full my-2 text-3xl font-bold leading-tight text-center" >Introduction to our Speakers</h3>
            <div className="w-full mb-4">
              <div className="h-1 mx-auto gradient w-64 opacity-25 my-0 py-0 rounded-t"></div>
            </div>

            <div className="w-full md:w-1/2 p-8 flex flex-col flex-grow flex-shrink">
              <div className="flex-1 bg-white rounded-t rounded-b-none overflow-hidden shadow">
                <a href="#" className="flex flex-wrap no-underline hover:no-underline">
                  {/* <p className="w-full text-gray-600 text-xs md:text-sm px-6">
                  </p> */}
                  <div className="flex justify-center px-56 pt-4">
                  <img className="w-20" src={dev}/>
                  </div>
                  <div className="w-full font-bold text-xl text-gray-800 pl-48 py-4 ">Devaiah Bopanna</div>
                    <p className="text-gray-800 text-base px-4 mb-5">
                        <li>
                            Co-Founder of All Things Small, a media company dedicated to telling true stories out of the Indian subcontinent
                        </li>
                        <li className="mt-2">
                            Former Head Writer at All India Bakchod
                        </li>
                        <li className="mt-2">
                            Former Copywriter at Ogilvy
                        </li>
                        <li className="mt-2">
                            Writes columns for FirstPost, The Print, The Hindu and other illustrious publications  
                        </li>
                    </p>
                </a>
              </div>
            </div>

            <div className="w-full md:w-1/2 p-8 flex flex-col flex-grow flex-shrink">
              <div className="flex-1 bg-white rounded-t rounded-b-none overflow-hidden shadow">
                <a href="#" className="flex flex-wrap no-underline hover:no-underline">
                  {/* <p className="w-full text-gray-600 text-xs md:text-sm px-6">
                  </p> */}
                  <div className="flex justify-center px-64 pt-4">
                    <img className="w-full" src={anj}/>
                  </div>
                  <div className="w-full font-bold text-xl text-gray-800 px-2 py-4 text-center">Anjana Kamath</div>
                    <p className="text-gray-800 text-base px-4 mb-5">
                        <li>
                            Co-founder of Namami Vigneshwar Essentials - production and distribution of organic essential and edible oils
                        </li>
                        <li>
                            Director of Kamath Auto Recyclers (Kaarz), a startup revolutionizing sustainable automobile recycling 
                        </li>
                        <li>
                            She has showcased her innovation at the United Nations twice, and has met Narendra Modi during one UN event
                        </li>
                        <li>
                            She writes policy papers to NITI Aayog on transport, infrastructure and connectivity, and was part of the Global Entrepreneurship Summit 
                        </li>
                        <li>
                            She has been a fashion model and an Eva Miss India finalist, along with being a trained Hindustani vocalist, a freelance artist and a freelance dancer.
                        </li>
                    </p>
                </a>
              </div>
            </div>

            {/*<div className="w-full md:w-1/3 p-8 flex flex-col flex-grow flex-shrink">
              <div className="flex-1 bg-white rounded-t rounded-b-none overflow-hidden shadow">
                <a href="#" className="flex flex-wrap no-underline hover:no-underline">
                  {/* <p className="w-full text-gray-600 text-xs md:text-sm px-6">
                  </p> 
                  <div className="w-full font-bold text-xl text-gray-800 px-2 py-4 text-center">Choosing Your Post-Grad Stream, and Networking</div>
                    <p className="text-gray-800 text-base px-4 mb-5">
                        <li>
                          Explore different streams related to your career path, reach out to professors 
                          from universities to know more about what they do
                        </li>
                        <li>
                          Reach out to current students pursuing their Masters programs, 
                          and get a better picture about the course, the student culture, and the university.
                        </li>
                        <li>
                          Connect with professors doing research on topics you’re interested 
                          in - Build a relationship which can help you when you eventually pursue your course
                        </li>
                        <li>
                         Get recommendations from your professors and project guides!
                        </li>
                    </p>
                </a>
              </div>
                </div>*/}

            </div>

            <section class="bg-white border-b py-8 px-8 text-gray-800">
            <div class="container max-w-5xl mx-auto m-8">
              <h2 class="w-full my-2 text-3xl font-bold leading-tight text-center">The Speakers Journey</h2>
              <div className="w-full mb-6">
                <div className="h-1 mx-auto gradient w-64 opacity-25 my-0 py-0 rounded-t"></div>
              </div>

              <div className="flex flex-wrap items-center justify-center">
                <div className="w-full  p-6 flex flex-col flex-grow flex-shrink">
                  <div className="flex-1 bg-white rounded-t rounded-b-none overflow-hidden shadow">
                  
                      <div className="w-full font-bold text-xl text-center text-gray-800 px-6">Devaiah on the beginning of his career path</div>
                      <p className="text-gray-800 text-base  mb-5 mt-4">
                        <li className="pl-4">His foray into engineering wasn’t what he intended, and he decided to change his career path during early days of his engineering.</li>
                        <li className="pl-4">Backed his prodigious skill of writing, did a couple of internships at creative agencies, and joined Ogilvy after graduation. </li>
                        <li className="pl-4">Persevered to continue in his field despite hardships like the 2008 recession, and the impacted market. </li>
                      </p>
                  
                  </div>
                </div>

                <div className="w-full p-6 flex flex-col flex-grow flex-shrink">
                  <div className="flex-1 bg-white rounded-t rounded-b-none overflow-hidden shadow">
                  
                      <div className="w-full font-bold text-xl text-center text-gray-800 px-6">Anjana on her foray into entrepreneurship during her engineering days</div>
                      <p className="text-gray-800 text-base  mb-5 mt-4">
                        <li className="pl-4">Anjana credits her parents, who are business people, to sparking the entrepreneurial thought.</li>
                        <li className="pl-4">She chose to work on an idea suggested by her father, and took it up as her final year project, and wanted to develop it into a startup. </li>
                        <li className="pl-4">The idea for the essential oil business came from a real-life need for better quality of edible oil. </li>
                        <li className="pl-4">Finding investors who believe in the product is imperative, and focussing on building the idea takes higher precedence over funding. Bootstrapping makes you serious about your venture.</li>
                        <li className="pl-4">Getting the right network to hone and mentor the business is beneficial. Anjana credits her stint at DLabs, ISB to giving her exposure to building the right networks, and optimizing her operations. </li>
                        <li className="pl-4">Getting accredited by the Government of India as a startup provides a medley of benefits, and they can be helpful in reducing legal and regulatory workload.  </li>
                      </p>
                  
                  </div>
                </div>
              </div>
              {/*<div class="flex flex-wrap -mx-4 overflow-hidden text-gray-600">

                <div class="my-4 px-4 w-1/3 overflow-hidden ">
                  Searching for relevant jobs is easy on LinkedIn, as the platform analyzes your profile, your interests and shows you jobs based on your expectations. Update your preferences, and get the most relevant opportunities
                </div>

                <div class="my-4 px-4 w-1/3 overflow-hidden ">
                  Reach out to suitable people in companies - Know what your future job might entail, know the company culture and more
                </div>

                <div class="my-4 px-4 w-1/3 overflow-hidden ">
                  Follow companies on LinkedIn , engage with their posts, start a conversation , score brownie points.<br/>
                  <a style={{color: "blue"}} href="https://premium.linkedin.com/content/premium/global/en_us/index/jobsearch">LinkedIn Premium</a> can help you analyze your performance, know if recruiters are looking into your profile, get data about other applicants and more. 
                </div>

              </div>*/}
            </div>
          </section>
          
          <section class="bg-purple border-b py-8 px-8 ">
            <div class="container max-w-5xl mx-auto m-8">
              <h2 class="w-full my-2 text-3xl font-bold leading-tight text-center">Insights into Entrepreneurship</h2>
              <div className="w-full mb-6">
                <div className="h-1 mx-auto gradient w-64 opacity-25 my-0 py-0 rounded-t"></div>
              </div>
              <div class="flex flex-wrap -mx-4 overflow-hidden">

                <div class="my-4 px-4 w-1/4 overflow-hidden ">
                <img className="h-6 w-6" src={oneImg} />
                  Access to information, and knowledge is readily available. The efficiency of knowledge assimilation has increased, and utilize videos, tutorials, podcasts to maximize your learning curve.
                </div>

                <div class="my-4 px-4 w-1/4 overflow-hidden ">
                <img className="h-6 w-6" src={twoImg} />
                  Figure out what you want to do by doing. Practise. Consistent practise is essential to achieving mastery. 
                </div>

                <div class="my-4 px-4 w-1/4 overflow-hidden ">
                <img className="h-6 w-6" src={threeImg} />
                  Doing research about your industry, career path and job trajectories will help you when you eventually switch jobs or careers
                </div>

                <div class="my-4 px-4 w-1/4 overflow-hidden ">
                <img className="h-6 w-6" src={fourImg} />
                  Work hard on your career, along with the skills. Network with relevant people, take informed, well-researched decisions
                </div>

                <div class="my-4 px-4 w-1/4 overflow-hidden ">
                <img className="h-6 w-6" src={fiveImg} />
                  Networking can be very impactful, do start ASAP if you already haven’t.
                 
                </div>

                <div class="my-4 px-4 w-1/4 overflow-hidden ">
                <img className="h-6 w-6" src={sixImg} />
                  Do not force yourself to do something out of FOMO
                </div>

                <div class="my-4 px-4 w-1/4 overflow-hidden ">
                <img className="h-6 w-6" src={sevenImg} />
                  Introspect regularly, without fail 
                </div>

                <div class="my-4 px-4 w-1/4 overflow-hidden ">
                <img className="h-6 w-6" src={eightImg} />
                  It’s never too late to do what you’re passionate about. You’re never short of time to switch careers. 
                </div>

                <div class="my-4 px-4 w-1/4 overflow-hidden ">
                <img className="h-6 w-6" src={nineImg} />
                  Do a risk vs reward analysis before major career switches. 
                </div>
              </div>
            </div>
          </section>

          <section class="bg-white border-b py-8 px-8 text-gray-800">
            <div class="container max-w-5xl mx-auto m-8">
              <h2 class="w-full my-2 text-3xl font-bold leading-tight text-center">Wrap Up</h2>
              <div className="w-full mb-6">
                <div className="h-1 mx-auto gradient w-64 opacity-25 my-0 py-0 rounded-t"></div>
              </div>

              <p className="text-center">The event covered these salient points, and also touched upon the time Devaiah and Anjana spent at BMSCE, and their cherished moments from that time period. <br/>

                And that’s a wrap on the first Fireside Chat event by BMSCE Alumni Club. Who are we, and why are we doing this? <br/><br/>

                We’re just a bunch of people from different walks of life with one common factor - BMSCE. Folks from different industries, geographies, career paths, etc. put under a single umbrella, with the objective of connecting with fellow alumni, expanding our networks, giving back to our community and supporting our cause. <br/><br/>

                Do you think you can contribute to your tribe, bring something new to the table, or just have a good time with your fellow BMSians, join us! 
              </p>

            </div>
          </section>


      </div>
            
      }

    >
    
      <SEO
        title="Events:BMSCE Alumni Club"
        keywords={[`bmsce`, `alumni`, `club`, `getscrewed`]}
      />

    </BlogEventLayout>
  );
}

export default EventsBlogDetailsPage;
